import { LinkedIn } from "@material-ui/icons";

export const contactsData = {
    email: 'genise.butler@outlook.com',
    phone: '+16023665873',
    address: 'Phoenix, AZ',
    

    sheetAPI: ''
}